import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8Z",
			stroke: "currentColor",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 8C18.5 9.38071 17.3807 10.5 16 10.5C14.6193 10.5 13.5 9.38071 13.5 8C13.5 6.61929 14.6193 5.5 16 5.5C17.3807 5.5 18.5 6.61929 18.5 8Z",
			stroke: "currentColor",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 18H22V16C21 14 19 13 16 13C15.2704 13 14.5999 13.0592 13.9885 13.1775",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 18H13L14 16C14 16 12.5 13 8 13C3.5 13 2 16 2 16L3 18Z",
			stroke: "currentColor",
			strokeLinejoin: "round",
			fill: "currentColor"
		})
	]
});
export default SvgUsers;
